import login_bgImg from "./login_bg.png";
import logoImg from "./logo.png";

const images = {
  login_bg: login_bgImg,
  logo: logoImg,
};

export default images;
